export const getPresenceColor = (presence: string) => {
  switch (presence) {
    case "Answered":
      return "text-call-status-answered font-semibold";
    case "Available":
      return "text-call-status-available font-semibold";
    case "Missed":
      return "text-call-status-missed font-semibold";
    case "Busy":
      return "text-call-status-busy font-semibold";
    case "Abandoned":
      return "text-call-status-abandoned font-semibold";
    case "Transferred":
      return "text-call-status-transferred font-semibold";
    case "In A Call":
      return "text-call-status-in-a-call font-semibold";
    case "In An Internal Call":
      return "text-call-status-in-an-internal-call font-semibold";
    case "Offline":
      return "text-primary font-semibold";
    case "Do Not Disturb":
      return "text-call-status-danger font-semibold";
    case "Away":
      return "text-call-status-away font-semibold";
    case "Break":
      return "text-call-status-break font-semibold";
    case "Be Right Back":
      return "text-call-status-be-right-back font-semibold";
    case "Off Work":
      return "text-call-status-off-work font-semibold";
    case "Present Unknown":
      return "text-call-status-present-unknown font-semibold";
    case "Inactive":
      return "text-call-status-inactive font-semibold";
    case "Out Of Office":
      return "text-call-status-out-of-office font-semibold";
    default:
      return "";
  }
};

export const getDirectionColor = (direction: string) => {
  switch (direction) {
    case "Inbound":
      return "text-direction-inbound font-semibold";
    case "Inbound Direct":
      return "text-direction-inbound-direct font-semibold";
    case "Outbound":
      return "text-direction-outbound font-semibold";
    case "Internal":
      return "text-direction-internal font-semibold";
    default:
      return "";
  }
};
